import { Action, createFeatureSelector } from "@ngrx/store";

export interface HydratedState { }

export function hydratedReducer(state: boolean = false, action: Action): any {
  return state;
}

export const isHydrated = createFeatureSelector<boolean>(
  "hydrated"
);
